export default function CTA() {
  return (
    <section className="px-4 md:px-6 pb-4 md:pb-6">
      <div className="rounded-[40px] md:rounded-[48px] overflow-hidden flex flex-col md:flex-row min-h-[300px] md:h-[394px]">
        {/* Image panel */}
        <div className="relative md:w-[312px] h-56 md:h-full flex-none overflow-hidden rounded-tl-[40px] md:rounded-tl-3xl rounded-tr-[40px] md:rounded-tr-none rounded-bl-none md:rounded-bl-3xl">
          <img
            src="/assets/cta-bg.png"
            alt="Community members"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        {/* Text panel */}
        <div className="bg-zinc-900 flex-1 flex flex-col items-center justify-between gap-6 p-8 md:p-10 rounded-bl-[40px] md:rounded-bl-none rounded-br-[40px] md:rounded-br-[48px] md:rounded-tr-[48px]">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-zinc-100 leading-tight text-center">
            Viva a experiência de criar ou participar de uma comunidade de ensino
          </h2>
          <p className="text-sm md:text-base text-zinc-100/70 leading-7 text-center max-w-lg">
            Convide e faça amigos para aprender juntos. Crie grupos de ensino-aprendizagem de
            forma estruturada e intuitiva. Acompanhe, direcione e cresça com sua comunidade.
          </p>
          <a
            href="#"
            className="btn btn-md bg-zinc-100 text-zinc-900 hover:bg-white border-zinc-100 rounded-full font-semibold"
          >
            Criar comunidade
          </a>
        </div>
      </div>
    </section>
  )
}
